import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Kit de Inicio Rápido',
    desc: 'Empezá hoy mismo en menos de 10 minutos sin dudas'
  }, {
    num: '02',
    title: 'Calendario 30 Días',
    desc: 'Un mes entero de actividades diarias sin improvisar'
  }, {
    num: '03',
    title: 'Guía Familiar',
    desc: '12 actividades para hacer en familia con momentos reales de conexión'
  }, {
    num: '04',
    title: 'Cuaderno de Recuerdos',
    desc: 'Disparadores de memoria emocional con referencias argentinas'
  }, {
    num: '05',
    title: 'Checklist de Hábitos',
    desc: 'Los 10 hábitos que más cuidan la mente con plan de 30 días'
  }, {
    num: '06',
    title: 'Actividades Express',
    desc: '25 actividades de 3 a 15 minutos para días sin energía'
  }];
  return <section className="py-20 px-4 bg-cream" data-id="element-17">
      <div className="max-w-5xl mx-auto" data-id="element-18">
        <div className="text-center mb-16" data-id="element-19">
          <h2 className="text-3xl md:text-5xl font-bold text-blue-900 flex items-center justify-center gap-4 flex-wrap" data-id="element-20">
            <Gift className="w-10 h-10 text-amber-500" data-id="element-21" />6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-slate-600 mt-4 font-medium" data-id="element-22">
            — SIEMPRE INCLUIDOS —
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-23">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-ivory rounded-2xl p-6 shadow-md border border-stone-200 relative overflow-hidden group hover:border-amber-400 transition-colors" data-id="element-24">
              <div className="absolute -right-4 -top-4 w-24 h-24 bg-amber-100 rounded-full opacity-50 group-hover:scale-150 transition-transform duration-500" data-id="element-25" />
              <div className="relative z-10" data-id="element-26">
                <div className="text-amber-500 font-bold text-lg mb-2 flex items-center gap-2" data-id="element-27">
                  <Gift className="w-5 h-5" data-id="element-28" /> Bono #{bonus.num}
                </div>
                <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-29">
                  {bonus.title}
                </h3>
                <p className="text-slate-600 mb-6" data-id="element-30">{bonus.desc}</p>
                <div className="inline-block bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-sm font-bold border border-blue-100" data-id="element-31">
                  Valor $5.000{' '}
                  <span className="text-blue-600 line-through opacity-50 ml-1" data-id="element-32"></span>{' '}
                  → GRATIS
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-amber-500 rounded-3xl p-8 text-center shadow-xl max-w-3xl mx-auto" data-id="element-33">
          <p className="text-blue-950 text-lg md:text-xl font-medium mb-2" data-id="element-34">
            Valor total de los bonos
          </p>
          <div className="text-3xl md:text-5xl font-bold text-blue-950 flex items-center justify-center gap-4 flex-wrap" data-id="element-35">
            <span className="line-through opacity-60" data-id="element-36">$0</span>
            <span data-id="element-37">→ GRATIS</span>
          </div>
          <p className="text-blue-900 font-bold mt-2" data-id="element-38">con tu Megapack</p>
        </motion.div>
      </div>
    </section>;
}